// extracted by mini-css-extract-plugin
export var bullets = "index-module--bullets--5zDHv";
export var fade = "index-module--fade--WZFFH";
export var fade_bullets = "index-module--fade_bullets--rNyXE";
export var float_mascot_container = "index-module--float_mascot_container--6Cp14";
export var hero_container = "index-module--hero_container--7UQyG";
export var hero_form_container = "index-module--hero_form_container--seD+N";
export var hero_text = "index-module--hero_text--N+K+C";
export var hero_text_form = "index-module--hero_text_form--g-t0b";
export var homepage_hero = "index-module--homepage_hero--VIwqD";
export var installment_link = "index-module--installment_link--en2r-";
export var installment_scheme = "index-module--installment_scheme--rJDzz";
export var mascot_container = "index-module--mascot_container--Lue6w";
export var mascot_video_container = "index-module--mascot_video_container--Cp5Lt";
export var tamil = "index-module--tamil--AgYB7";
export var video_container = "index-module--video_container--JOWhA";